import { Injectable } from '@angular/core';

import { NavController } from '@ionic/angular';
import Utils from '../../shared/utilities/utils';
import { NavigationStateService } from '../services/navigation-state.service';

@Injectable({
  providedIn: 'root'
})
export class FastTrackGuardService  {
  constructor(
    private navController: NavController,
    private navigationStateService: NavigationStateService
  ) {}

  canActivate(): boolean {
    if (
      !this.navigationStateService.getCurrentUrl().includes('/fast-track') &&
      !this.navigationStateService
        .getCurrentUrl()
        .includes('/code-confirmation') &&
      Utils.isEmpty(this.navigationStateService.getPreviousUrl())
    ) {
      this.navController.navigateRoot(['/appointments']);
      return false;
    }
    return true;
  }
}
